import type { EventOccurrenceViewModel, FunctionViewModel } from '@trinnvis/dabih-api-client';
import type { OrganizationState } from '../../types';
import type { EventInstance } from './event-instance';
import { listNamesAsText } from '../employees/list-names-as-text';
import { eventDoneText } from './event-done-text';
import type { ContactsAsUsers } from '../partners/contacts-as-users';
import type { SelectDropdownOption } from '../../../library/editors/elements/select-dropdown-option';
import { eventAssigneesText } from '../../eventAssigneesText';
import { t } from 'src/i18n';

export function taskEventTodoItemsFunction(
  events: EventOccurrenceViewModel[],
  organization: OrganizationState,
  employeesAndContactsOptions: SelectDropdownOption[],
  employeeNamesI: { uuid: string; status: string; name: string }[],
  functions: FunctionViewModel[],
  contacts: ContactsAsUsers[],
  organizationId: number,
  currentUserUuid: string,
  singleUserVersion: boolean,
): EventInstance[] {
  const result: EventInstance[] = [];
  events.forEach(function (event) {
    if (event.date === null || event.date === undefined) {
      let functionName = '';
      let employeeNamesDisplay = '';
      let myTask = true;
      if (!singleUserVersion) {
        const employeesList = event.employees ?? [];
        const employeeNamesList = listNamesAsText(employeeNamesI, employeesList);
        employeeNamesDisplay = employeeNamesList.charAt(0).toUpperCase() + employeeNamesList.slice(1);
        if (event.functionUuid) {
          functionName = organization.functionsById[event.functionUuid].name ?? '';
        }
        myTask = employeesList.includes(currentUserUuid) || event.functionUuid !== '';
      }
      if (event.contacts && event.contacts.length) {
        myTask = event.contacts.includes(currentUserUuid);
      }
      let doneText = '';
      if (event.doneDate) {
        doneText = t('content.donePrefix') + eventDoneText(event, employeesAndContactsOptions, singleUserVersion);
      }
      let sortTime = '1000-01-01';
      if (event.doneDate) {
        sortTime = event.doneDate;
      }
      const occurrence = event;
      if (occurrence) {
        result.push({
          uuid: occurrence.uuid,
          event,
          time: '',
          sortTime: sortTime,
          dateAndTimeDisplay: t('library.todo.soonest'),
          eventUuid: event.uuid,
          eventName: event.name !== undefined ? event.name : '',
          eventNotes: '', // TODO event.notes,
          href: '/account/' + organizationId + '/' + 318434 + '/eventOccurrences/' + occurrence.uuid,
          dayTask: false,
          employees: event.employees,
          employeeNames: employeeNamesDisplay,
          functionUuid: event.functionUuid,
          functionName: functionName,
          contacts: event.contacts,
          assignee: eventAssigneesText(event, functions, employeeNamesI, contacts),
          myTask: myTask,
          timeOfDayDisplay: '',
          dateTimeForOrdering: '1000-01-01 00:00',
          doneDate: event.doneDate,
          doneByEmployeeUuid: event.doneByEmployeeUuid,
          doneByContactPersonUuid: event.doneByContactPersonUuid,
          doneText,
          accessible: true,
          locked: false,
          hasDraft: occurrence.hasDraft,
        });
      }
    }
  });
  return result;
}
